import { parameter } from "./Parameter/Naming";

class ExtensibleFunction extends Function {
  constructor(f) {
    return Object.setPrototypeOf(f, new.target.prototype);
  }
}

/**
 * 
 */
export class GenericFunction extends ExtensibleFunction {
  /**
   * 
   * @param {Function} f Function to apply to a list of values
   * @param {Object} details Details describing the function and its properties
   * @param {String} details.label Label for the function
   * @param {Object[]} details.parameters List of valid parameters for the function
   */
  constructor(f, {label, parameters, description, maxInputSize = 1} = {}) {
    super(f);
    this.label = label ?? f.name ?? '';
    this.description = description ?? '';
    this.parameters = parameters ?? [];
    this.maxInputSize = maxInputSize;
  }

  getDefaultParameterMap() {
    let output = {};

    for (let p of this.parameters) {
      if (p.default) {
        output[p.name] = p.default;
      } else {
        switch(p.type) {
          case parameter.TYPE.NUMBER:
            output[p.name] = 0; break;
          case parameter.TYPE.SERIES:
            output[p.name] = ''; break;
          case parameter.TYPE.NUMBER_ARRAY:
            output[p.name] = [0]; break;
          case parameter.TYPE.SERIES_ARRAY:
            output[p.name] = ['']; break;
        }
      }
    }
    return output;
  }
}